export type ManualType = 'coach' | 'participant';

const MANUALS: Record<ManualType, { nl: string; fr: string }> = {
  coach: {
    nl: 'manuals/NL - Handleiding HUB - Coaches - 21.04.26.pdf',
    fr: 'manuals/FR - Guide HUB - Coach - 21.04.26.pdf',
  },
  participant: {
    nl: 'manuals/NL - Handleiding HUB - Deelnemer - 21.04.26.pdf',
    fr: 'manuals/FR - Guide HUB - Participant - 21.04.26.pdf',
  },
};

/** Accepts both user languages ('nl-be', 'fr') and i18n locales ('nl', 'fr'). */
export function getManualPath(type: ManualType, language: string | null | undefined): string {
  const lang = (language || '').toLowerCase().startsWith('fr') ? 'fr' : 'nl';
  return MANUALS[type][lang];
}
